import React, { useState, useEffect } from "react";
import { NAV, PROFILE } from "@/data/portfolio";
import { Menu, X } from "lucide-react";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 bg-background ${scrolled ? "border-b border-border" : ""}`}
    >
      <nav className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif text-lg italic text-foreground hover:text-accent transition-colors"
        >
          Mohammad Ashraf
        </a>

        <ul className="hidden md:flex items-center gap-6">
          {NAV.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                data-testid={item.testid}
                className="text-sm text-quiet hover:text-foreground hover:underline underline-offset-4 transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href={PROFILE.resume}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="resume-download-button"
              className="text-sm text-accent hover:text-foreground underline underline-offset-4"
            >
              Résumé ↗
            </a>
          </li>
        </ul>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-foreground p-1"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-background border-t border-border">
          <ul className="flex flex-col px-6 py-5 gap-3">
            {NAV.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-${item.testid}`}
                  className="text-base text-foreground hover:text-accent"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={PROFILE.resume}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-resume-download-button"
                className="text-base text-accent underline underline-offset-4"
              >
                Résumé ↗
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};
